import { gsap } from 'gsap';
const id = 'backdrop';

const initBackdrop = function () {
  $('body').append(
    $(`
      <div id="${id}"></div>
      <style>
          #${id} {
              position: fixed;
              top: 0;
              left: 0;
              width: 100vw;
              height: 100vh;
              opacity: 0;
              visibility: hidden;
              background-color: rgba(0,0,0, 0.3);
              transition: opacity .1s, visibility .1s;
              z-index: 11;
          }
      </style>
  `),
  );

  $(`#${id}`).on('click', function () {
    const $openCountrySwitcher = $('.country-switcher__modal.open');
    if ($openCountrySwitcher.length) {
      $openCountrySwitcher.removeClass('open');
    }

    const $openMinicart = $('.minicart__drawer.minicart__drawer--open');
    if ($openMinicart.length) {
      $openMinicart.removeClass('minicart__drawer--open');
    }

    const $openDesktopMenu = $('.header__desktop-menu--drawer__inline-elements__link'); 
    if ($openDesktopMenu.length) {
      $openDesktopMenu.removeClass('open'); 
      $('html').css('overflow-y', '');
      let $header_announcement_container = $('#header-announcement-container');
      let $announcement_bar = $('#shopify-section-announcement-bar');
      setTimeout(function(){
        $header_announcement_container.css('z-index', '');
        if ($announcement_bar.length > 0) {
          $announcement_bar.css('z-index', '0');
        }
      }, 250);
    }

    const $productDrawer = $('.product__drawer'); 
    if ($productDrawer.length) {
      $productDrawer.removeClass('open'); 
    }

    const $deskSearchBar = $('.header__search-popup');
    if ($deskSearchBar.length > 0) {

      $deskSearchBar.removeClass('open');
      let $header_announcement_container = $('#header-announcement-container');
      let $announcement_bar = $('#shopify-section-announcement-bar');
      let $header = $('.header__container'); 

      $header.removeClass('force-opacity');
      if ($(window).scrollTop() === 0) {
        $header.addClass('apply-transparency');
      }
      hideBackdrop(); 
      setTimeout(function(){
        $header_announcement_container.css('z-index', '');
        if ($announcement_bar.length > 0) {
          $announcement_bar.css('z-index', '');
        }
      }, 100); 

    }

    hideBackdrop();
  });
};

const showBackdrop = function () {
  gsap.to(`#${id}`, { autoAlpha: 1, duration: 0.1 });
  document.querySelector('html').classList.add('backdrop-open');
};

const hideBackdrop = function () {
  gsap.to(`#${id}`, { autoAlpha: 0, duration: 0.1 });
  document.querySelector('html').classList.remove('backdrop-open');
};

export { showBackdrop, hideBackdrop, initBackdrop };
